import dayjs from "dayjs";
import localeData from "dayjs/plugin/localeData";
import customParseFormat from "dayjs/plugin/customParseFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import isoWeek from "dayjs/plugin/isoWeek";
import utc from "dayjs/plugin/utc";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";

dayjs.extend(localeData);
dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);
dayjs.extend(isoWeek);
dayjs.extend(utc);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

export const convertAmPmTo24 = (t) => {
  if (!(t.includes("am") || t.includes("pm"))) return t;
  const time = +t.replace("am", "").replace("pm", "");

  if (Number(time)) {
    if (t.includes("pm")) {
      return 12 + time;
    } else {
      return time;
    }
  }
};

export default dayjs;
